import Weather from "./Weather.js";

import Footer from "./Footer";

import "./Weather.css";

export default function App() {
  return (
    <div className="App">
      <div className="weather-app">
        <Weather defaultCity="London" />
      </div>
      <Footer />
    </div>
  );
}
